import { Trans } from '@lingui/macro'
import { useGlobals } from 'context'
import { css, isAuthorized, styles } from 'helpers'
import React from 'react'
import { Typography } from 'webbook-airways'
// import Lock from '@material-ui/icons/LockOutlined'
// import LockOpen from '@material-ui/icons/LockOpenOutlined'
// import EventAvailable from '@material-ui/icons/EventAvailableOutlined'

export default function AccessChip({
  isPlanned,
  plannedText,
  active,
  allowedRoles = []
}) {
  const { global } = useGlobals()
  const isActive = active || isAuthorized(global.user.roles, allowedRoles)
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center'
        // padding: '6px 14px',
        // borderRadius: 4
        // backgroundColor: isPlanned
        //   ? '#FDEAD3'
        //   : isActive
        //   ? 'rgba(235,249,233,1)'
        //   : '#FEE4E4'
      })}
    >
      {/* {isPlanned ? (
        <EventAvailable
          style={{ fontSize: 20, color: styles.colors.paleOrange }}
        />
      ) : !isActive ? (
        <Lock style={{ fontSize: 20, color: styles.colors.paleRed }} />
      ) : (
        <LockOpen style={{ fontSize: 20, color: styles.colors.paleGreen }} />
      )} */}
      <Typography
        style={{
          // marginLeft: 7,
          fontWeight: 500,
          color: isPlanned
            ? styles.colors.paleOrange
            : isActive
            ? styles.colors.paleGreen
            : styles.colors.paleRed
        }}
      >
        {isPlanned ? (
          plannedText || <Trans>We are building this</Trans>
        ) : isActive ? (
          <Trans>You have access</Trans>
        ) : (
          <React.Fragment>
            <Trans>Call</Trans> <strong>+45 75 54 20 81</strong>{' '}
            <Trans>for access</Trans>
          </React.Fragment>
        )}
      </Typography>
    </div>
  )
}
